const blindMatrix = [
  // Protanopia]
  [
    [0.56667, 0.43333, 0.0],
    [0.55833, 0.44167, 0.0],
    [0.0, 0.24167, 0.75833]
  ],

  // Deuteranopia
  [
    [0.625, 0.375, 0.0],
    [0.7, 0.3, 0.0],
    [0.0, 0.3, 0.7]
  ],

  // Tritanopia
  [
    [0.95, 0.05, 0.0],
    [0.0, 0.43333, 0.56667],
    [0.0, 0.475, 0.525]
  ],

  // Achromatopsia 
  [
    [0.299, 0.587, 0.114],
    [0.299, 0.587, 0.114],
    [0.299, 0.587, 0.114]
  ],

  // Protanomaly
  [
    [0.817, 0.183, 0.0],
    [0.333, 0.667, 0.0],
    [0.0, 0.125, 0.875]
  ],

  // Deuteranomaly
  [
    [0.8, 0.2, 0.0],
    [0.258, 0.742, 0.0],
    [0.0, 0.142, 0.858]
  ],

  // Tritanomaly 
  [
    [0.967, 0.033, 0.0],
    [0.0, 0.733, 0.267],
    [0.0, 0.183, 0.817]
  ],

  // Blue Cone Monochromacy
  [
    [0.143, 0.143, 0.714],
    [0.143, 0.143, 0.714],
    [0.143, 0.143, 0.714]
  ]
]


export default blindMatrix